/*eslint unicode-bom: ["error", "always"]*/
import styles from "./access.module.css";
import React from 'react';

function Offline() {

    return (
        <div className={styles.noAccess}>
            <div className={styles.noAccessTitle}>Oops...!</div>
            <div>
                <p>
                    Du er visst offline.
                </p>
                <p>
                    Pr&oslash;v p&aring; nytt n&aring;r du er online igjen.
                </p>
            </div>
        </div>
    );
}

export default Offline;
